import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MarketingCarousel from '../components/marketing-carousel';
import MuiRaisedButton from 'material-ui/RaisedButton';
import { Navigation } from '../../../navigation/react-redux-nav';
import { makeMonthlyPayment } from '../../../store/ducks/payment';
import styles from '../../../shared-styles';
import './phoenix-plan-options.css';

const labelStyle = {
  textTransform: 'none',
  fontWeight: 300,
  lineHeight: '48px'
};

const shortLabelStyle = {
  lineHeight: '35px'
};

class PhoenixPlanOptions extends Component {
  monthlyMembershipSelected = async () => {
    try {
      await this.props.makeMonthlyPayment();
    } catch (err) {
      // do nothing
    }
  }

  render() {
    return (
      <div className="phoenix-plan-component">
        <MarketingCarousel />
        <div className="plan-options-component">
          <div className="plan-options-container">
            <div className="plan-options-row">
              <div className="plan-options-column">
                <MuiRaisedButton
                  label={ <span><strong style={{ fontWeight: 600 }}>$8</strong>/month</span> }
                  onClick={ this.monthlyMembershipSelected }
                  primary={ true }
                  fullWidth={ true }
                  style={ styles.buttonStyle }
                  labelStyle={ labelStyle }
                />
              </div>
              <div className="plan-options-column">
                <Navigation.JumpTo page="shipping-address">
                  <MuiRaisedButton
                    className="plan-option-yearly"
                    label={ <span><strong>$96</strong>/year</span> }
                    primary={ true }
                    fullWidth={ true }
                    style={ styles.buttonStyle }
                    labelStyle={{ ...labelStyle, ...shortLabelStyle }}
                  />
                </Navigation.JumpTo>
              </div>
            </div>
            <Navigation.JumpTo page="activation-code">
              <a>Have an <strong>activation or promo code?</strong></a>
            </Navigation.JumpTo>
          </div>
        </div>
      </div>
    );
  }
}

PhoenixPlanOptions.propTypes = {
  makeMonthlyPayment: PropTypes.func.isRequired
};

export default connect(
  null,
  dispatch => ({
    makeMonthlyPayment: async () => {
      await dispatch(makeMonthlyPayment());
      dispatch(Navigation.forward());
    }
  })
)(PhoenixPlanOptions);
